import { tgimFetch } from './httpClient';
import { getTgimAccessToken } from './session';

export type TgimUserProfile = {
  openim_user_id: string;
  phone_e164?: string;
  email?: string;
  first_name: string;
  last_name: string;
  username?: string;
  bio: string;
  avatar_url?: string;
};

export type TgimUserProfilePatch = {
  first_name?: string;
  last_name?: string;
  username?: string;
  bio?: string;
  avatar_url?: string;
};

// `GET/PATCH /account/me`, `POST/DELETE /account/me/avatar` all require `Authorization: Bearer
// <access_token>` (`tg-im-backend/openapi/auth.yaml`'s `security: [bearerAuth]`) -- `tgimFetch`
// itself is also used pre-login (sms/email send+verify), so the bearer header is attached here per
// call rather than unconditionally inside `tgimFetch`.
async function authHeaders(): Promise<HeadersInit> {
  const accessToken = await getTgimAccessToken();
  return accessToken ? { Authorization: `Bearer ${accessToken}` } : {};
}

export async function fetchMyTgimProfile(): Promise<TgimUserProfile> {
  return tgimFetch('/account/me', { headers: await authHeaders() });
}

export async function updateMyTgimProfile(patch: TgimUserProfilePatch): Promise<TgimUserProfile> {
  return tgimFetch('/account/me', {
    method: 'PATCH',
    headers: await authHeaders(),
    body: JSON.stringify(patch),
  });
}

// `avatar_handlers.go`'s `AccountMeAvatarPost` reads the file from a multipart field literally
// named `file` -- verified against the real Go handler, not just the OpenAPI doc.
export async function uploadMyTgimAvatar(file: Blob): Promise<TgimUserProfile> {
  const formData = new FormData();
  formData.append('file', file);
  return tgimFetch('/account/me/avatar', {
    method: 'POST',
    headers: await authHeaders(),
    body: formData,
  });
}

export async function deleteMyTgimAvatar(): Promise<TgimUserProfile> {
  return tgimFetch('/account/me/avatar', {
    method: 'DELETE',
    headers: await authHeaders(),
  });
}
